import request from '@/utils/request'

/**
 * 新闻接口
**/
export function getNewsArticles(params = {}) {
  return request({
    method: 'POST',
    url: 'news.articles',
    data: params
  })
}
export function getNewsArticle(params = {}) {
  return request({
    method: 'POST',
    url: 'news.article',
    data: params
  })
}
export function getNewsEvents(params = {}) {
  return request({
    method: 'POST',
    url: 'news.events',
    data: params
  })
}
export function getNewsEvent(params = {}) {
  return request({
    method: 'POST',
    url: 'news.event',
    data: params
  })
}

/**
 * 院校接口
**/
export function getCollegeList(params = {}) {
  return request({
    method: 'POST',
    url: 'college.list',
    data: params
  })
}
export function getCollegeDetail(params = {}) {
  return request({
    method: 'POST',
    url: 'college.detail',
    data: params
  })
}

/**
 * 专业接口
**/
export function getMajorList(params = {}) {
  return request({
    method: 'POST',
    url: 'major.list',
    data: params
  })
}
export function getMajorDetail(params = {}) {
  return request({
    method: 'POST',
    url: 'major.detail',
    data: params
  })
}

/**
 * 顾问接口
**/
export function getConsultantList(params = {}) {
  return request({
    method: 'POST',
    url: 'agent.listto',
    data: params
  })
}
export function getConsultantRanking(params = {}) {
  return request({
    method: 'POST',
    url: 'agent.rankingto',
    data: params
  })
}
export function getConsultantDetail(params = {}) {
  return request({
    method: 'POST',
    url: 'agent.detailto',
    data: params
  })
}

/**
 * 客户接口
**/
export function sendCustomerReport(params = {}) {
  return request({
    method: 'POST',
    url: 'customer.report',
    data: params
  })
}

/**
 * 高考与招生接口
**/
export function getCeeStatistic(params = {}) {
  return request({
    method: 'POST',
    url: 'cee.statistic',
    data: params,
  })
}
export function getCeeScoreline(params = {}) {
  return request({
    method: 'POST',
    url: 'cee.scoreline',
    data: params,
  })
}
export function getCeeAdmission(params = {}) {
  return request({
    method: 'POST',
    url: 'cee.admission',
    data: params,
  })
}
export function getCeeEnrollment(params = {}) {
  return request({
    method: 'POST',
    url: 'cee.enrollment',
    data: params,
  })
}
export function getCeeAspiration(params = {}) {
  return request({
    method: 'POST',
    url: 'cee.aspiration',
    data: params
  })
}
export function getCeePreference(params = {}) {
  return request({
    method: 'POST',
    url: 'cee.preference',
    data: params
  })
}

/**
 * 测评接口
**/
export function getEvaluationId(params = {}) {
  return request({
    method: 'POST',
    url: 'evaluation.generateId',
    data: params
  });
}
export function getEvaluationQuestion(params = {}) {
  return request({
    method: 'POST',
    url: 'evaluation.question',
    data: params
  });
}
export function getEvaluationAnswer(params = {}) {
  return request({
    method: 'POST',
    url: 'evaluation.answer',
    data: params
  })
}
export function getEvaluationReport(params = {}) {
  return request({
    method: 'POST',
    url: 'evaluation.report',
    data: params
  })
}
export function getEvaluationPDF(params = {}) {
  return request({
    method: 'POST',
    url: 'evaluation.haspdf',
    data: params
  })
}

/**
 * 支付接口
**/
export function getPayment(params = {}) {
  return request({
    method: 'POST',
    url: 'payment.createorder',
    data: params
  })
}
export function getPaymentStatus(params = {}) {
  return request({
    method: 'POST',
    url: 'payment.checkstatus',
    data: params
  })
}
